import { gql } from '@urql/core';

import type { ResultCmsLanguage } from '@core-types/cms';
import type { Client, RequestPolicy, OperationResult } from '@urql/core';

const GET_LANGUAGES = gql`
  query CmsLanguages {
    cmsLanguages {
      id
      code
      name
    }
  }
`;

export const fetchCmsLanguages = async (
  client: Client,
  fetchOptions?: RequestInit,
  requestPolicy?: RequestPolicy,
): Promise<ResultCmsLanguage> => {
  const result = await gqlQuery(
    client,
    GET_LANGUAGES,
    {},
    () => {},
    fetchOptions,
    requestPolicy,
  );
  
  validateCmsLanguages(result);
  return result;
};

function validateCmsLanguages(
  cmsLanguages: OperationResult<ResultCmsLanguage>['data'],
): asserts cmsLanguages is ResultCmsLanguage {
  if (!cmsLanguages) throw new Error('ERR:: fetchCmsLanguages: not data available');
}
